import React, { useCallback, useContext, useEffect, useState } from 'react'
import UserContext from '../../contexts/UserContext'
import axios from 'axios' ;
import { useNavigate } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';

const Home = () => {
  const {user,setUser} = useContext(UserContext);
  const [zones,setZones] = useState([]);
  const [filteredZones, setFilteredZones] = useState([]);
  const [message,setMessage] = useState('')
  const [loading,setLoading] =useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  axios.defaults.withCredentials = true;

  const getZones = async () => {
    console.log("IN GETTING ZONES")
    await axios.get(`${process.env.REACT_APP_API_URI}/api/zones/getAllZones`,{withCredentials:true}).then((response)=>{
      if(response.data.success){
        setZones(response?.data?.data);
        setFilteredZones(response?.data?.data);
        setLoading(false);
      }else{
        const errorMessage = displayError(response,navigate,setUser);
        if(errorMessage){
          setMessage(errorMessage)
        }
        setLoading(false);
      }
    }).catch((err) => {
      const errorMessage = displayError(err,navigate,setUser);
      if(errorMessage){
        setMessage(errorMessage)
      }
      setLoading(false);
    })
  }  

  const requestPage = () => {
    navigate("/zc/create-request");
  };

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
      if(user){
        getZones();
      }
    }
    startup();
  },[user])

  // Handle search
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredZones(zones);
    } else {
      const lowerSearch = searchTerm.toLowerCase();
      setFilteredZones(
        zones.filter(zone =>
          zone.id?.toString().toLowerCase().includes(lowerSearch) ||
          zone.desc?.toLowerCase().includes(lowerSearch)
        )
      );
    }
  }, [searchTerm, zones]);

  const design = (
    <>
    <div className="wrapper my-5 mx-2">
      <div className="fab-container" onClick={()=>{setUser({ ...user, zone: null });requestPage()}}>
        <button className="fab-button bg-fmb">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </button>
        <span className="fab-text text-fmb">Create Forecast</span>
      </div>

      {/* Search Bar */}
      <div className="mx-3 my-4">
        <input
          type="text"
          placeholder="Search by Zone ID or Description..."
          className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-fmb focus:border-fmb"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {message && (
        <div className="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span className="block sm:inline">{message}</span>
        </div>
      )}

      { loading ? (  
        <div>Loading...</div>  
      ) : (
        filteredZones && filteredZones.length>0? (
          filteredZones.map((zone) => (
            <div key={zone._id} onClick={()=>navigate("zone",{state:zone})} className='flex flex-row justify-between bg-slate-50 rounded-md shadow-lg mx-3 my-2 p-3 border border-fmb-secondary cursor-pointer hover:bg-slate-100'>
              <div className="text-left">
                <h3 className='font-semibold text-[16px] text-fmb'>Zone {zone.id} - {zone.desc}</h3>
                <p className='text-sm text-amber-700 font-semibold'>
                  {zone.coordinator && zone?.coordinator[0]?.name
                    ? zone?.coordinator[0]?.name.charAt(0).toUpperCase() + zone?.coordinator[0]?.name.slice(1)
                    : null}
                </p>
              </div>
              <div className='flex flex-col justify-center align-middle text-center'>
                <h5 className='text-2xl text-lime-700 font-semibold'>{zone.itemRequest?.length}</h5>
                <p className='text-xs text-gray-400'>Total Requests:</p>
              </div>
            </div>
          ))
        ):(
          <div className="text-center text-gray-500 mt-6">
            <h6>No Zones Found !</h6>
          </div>
        )
      )}
    </div>
    </>
  );
  return design;
}

export default Home
